import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserRolesService {

  private _commonapiUrl = `${environment.common}`;
  constructor(
    private _http: HttpClient
  ) { }

  getPermissions(role:any){
    return this._http.get<any>(`${this._commonapiUrl}/GetRolePermissions/${role}`);
  }
}
